export const paths = [{ "tag": "path", "att": { "d": "M6.2924 9.8284 4.436 11.6569 3 10.2427 7.3077 6l4.3078 4.2427-1.4359 1.4142-1.8565-1.8284V18H6.2924V9.8284zm9.3846 4.3432-1.8566-1.8285-1.4359 1.4142L16.6923 18 21 13.7573l-1.4359-1.4142-1.8565 1.8284V6H15.677v8.1716z" } }];
export const iconName = 'arrow-up-arrow-down';
export const arrowUpArrowDown = { iconName, paths };
export default paths;
